module.exports = __webpack_public_path__ + "img/sign-serve-icon.85fdc92d.png";